// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{.line-area-graph{zoom:75%}}.line-area-graph .title{display:block;font-size:12px;margin-top:-18px;text-align:center;text-transform:uppercase;width:100%}.line-area-graph .custom-tooltip{background-color:#fff;padding:8px}.line-area-graph .custom-tooltip .date{color:#666;font-weight:800;margin-bottom:4px}.line-area-graph .custom-tooltip .data-key-item{padding:4px 4px 4px 0}", ""]);
// Exports
module.exports = exports;
